import { render, staticRenderFns } from "./TintometricoEventos.vue?vue&type=template&id=71b0acb9"
import script from "./TintometricoEventos.vue?vue&type=script&lang=js"
export * from "./TintometricoEventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports